(() => {
  const initialized = new WeakSet();

  function initCartagenaFunnel(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const form = root.querySelector('[data-cp-form]');
    if (!form) return;

    const productInputs = Array.from(form.querySelectorAll('[data-cp-product]'));
    const fragrancePanel = form.querySelector('[data-cp-fragrance-panel]');
    const fragranceDialog = form.querySelector('[data-cp-fragrance-dialog]');
    const fragranceButtons = Array.from(form.querySelectorAll('[data-cp-fragrance]'));
    const fragranceOpenButton = form.querySelector('[data-cp-open-fragrances]');
    const fragranceCloseButtons = Array.from(form.querySelectorAll('[data-cp-close-fragrances]'));
    const fragranceDoneButton = form.querySelector('[data-cp-done-fragrances]');
    const fragrancePresetButtons = Array.from(form.querySelectorAll('[data-cp-fragrance-preset]'));
    const fivePresetGroup = form.querySelector('[data-cp-presets-five]');
    const tenPresetGroup = form.querySelector('[data-cp-presets-ten]');
    const fragranceCountElements = Array.from(form.querySelectorAll('[data-cp-fragrance-count]'));
    const fragranceRequiredElements = Array.from(form.querySelectorAll('[data-cp-fragrance-required]'));
    const fragranceSummary = form.querySelector('[data-cp-fragrance-summary]');
    const selectedImage = form.querySelector('[data-cp-selected-image]');
    const selectedTitle = form.querySelector('[data-cp-selected-title]');
    const selectedPrice = form.querySelector('[data-cp-selected-price]');
    const selectedSummary = form.querySelector('[data-cp-selected]');
    const submitButton = form.querySelector('[data-cp-submit]');
    const submitLabel = form.querySelector('[data-cp-submit-label]');
    const errorElement = form.querySelector('[data-cp-error]');
    const deliveryPanel = form.querySelector('.cp-cartagena__delivery');
    const dateInput = form.querySelector('[data-cp-date]');
    const giftToggle = form.querySelector('[data-cp-gift-toggle]');
    const giftMessageField = form.querySelector('[data-cp-gift-message-field]');
    const giftMessage = form.querySelector('[data-cp-gift-message]');
    const productDialogOpenButtons = Array.from(form.querySelectorAll('[data-cp-open-product]'));
    const productDialogs = Array.from(form.querySelectorAll('[data-cp-product-dialog]'));
    const chooseProductButtons = Array.from(form.querySelectorAll('[data-cp-choose-product]'));
    const directFragranceButtons = Array.from(form.querySelectorAll('[data-cp-select-product-open-fragrances]'));
    const selectedFragrances = new Map();
    let requiredFragrances = 0;

    const text = {
      selectProduct: root.dataset.errorProduct || 'Selecciona un kit.',
      selectFragrances: root.dataset.errorFragrances || 'Completa la selección de fragancias.',
      generic: root.dataset.errorGeneric || 'No pudimos continuar. Inténtalo de nuevo.',
      selectedPrefix: root.dataset.selectedPrefix || 'Seleccionadas',
      choose: root.dataset.chooseFragrances || 'Elegir fragancias',
      edit: root.dataset.editFragrances || 'Editar selección',
      processing: root.dataset.processing || 'Preparando pago…',
      checkout: root.dataset.checkoutLabel || 'Continuar al pago'
    };

    function bogotaDate() {
      try {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Bogota',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());
        const values = {};
        parts.forEach((part) => { values[part.type] = part.value; });
        return `${values.year}-${values.month}-${values.day}`;
      } catch (error) {
        return new Date().toISOString().slice(0, 10);
      }
    }

    if (dateInput) dateInput.min = bogotaDate();

    function currentProduct() {
      return productInputs.find((input) => input.checked) || null;
    }

    function trimFragrances(limit) {
      if (!limit || selectedFragrances.size <= limit) return;
      Array.from(selectedFragrances.keys()).slice(limit).forEach((key) => selectedFragrances.delete(key));
    }

    function normalizedSearch(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-');
    }

    function clearPresetState() {
      fragrancePresetButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
    }

    function applyFragrancePreset(button) {
      const presetRequired = Number.parseInt(button.dataset.presetRequired || '0', 10) || 0;
      if (!requiredFragrances || presetRequired !== requiredFragrances) return;
      const keywords = String(button.dataset.presetKeywords || '').split('|').filter(Boolean);
      const chosen = [];
      keywords.forEach((keyword) => {
        const normalizedKeyword = normalizedSearch(keyword);
        const fragranceButton = fragranceButtons.find((item) => {
          const haystack = normalizedSearch(item.dataset.fragranceSearch || `${item.dataset.fragranceName} ${item.dataset.fragranceLabel}`);
          return !chosen.includes(item) && haystack.includes(normalizedKeyword);
        });
        if (fragranceButton) chosen.push(fragranceButton);
      });
      if (chosen.length !== requiredFragrances) return;

      selectedFragrances.clear();
      chosen.forEach((item) => selectedFragrances.set(item.dataset.fragranceName, item.dataset.fragranceLabel || item.dataset.fragranceName));
      clearPresetState();
      button.setAttribute('aria-pressed', 'true');
      renderFragrances();
    }

    function renderFragrances() {
      trimFragrances(requiredFragrances);
      fragranceButtons.forEach((button) => {
        button.setAttribute('aria-pressed', selectedFragrances.has(button.dataset.fragranceName) ? 'true' : 'false');
      });

      fragranceCountElements.forEach((element) => { element.textContent = String(selectedFragrances.size); });
      fragranceRequiredElements.forEach((element) => { element.textContent = String(requiredFragrances); });
      if (fivePresetGroup) fivePresetGroup.hidden = requiredFragrances !== 5;
      if (tenPresetGroup) tenPresetGroup.hidden = requiredFragrances !== 10;

      const complete = requiredFragrances > 0 && selectedFragrances.size === requiredFragrances;
      if (fragranceDoneButton) fragranceDoneButton.disabled = !complete;
      if (fragranceOpenButton) {
        fragranceOpenButton.textContent = complete
          ? `${text.edit} (${selectedFragrances.size}/${requiredFragrances})`
          : `${text.choose} (${selectedFragrances.size}/${requiredFragrances})`;
      }

      if (fragranceSummary) {
        fragranceSummary.textContent = selectedFragrances.size
          ? `${text.selectedPrefix}: ${Array.from(selectedFragrances.values()).join(', ')}`
          : `${text.choose} (${requiredFragrances})`;
      }
    }

    function updateSelectedProduct(input) {
      if (!input) return;
      const nextRequiredFragrances = Number.parseInt(input.dataset.fragrancesRequired || '0', 10) || 0;
      if (nextRequiredFragrances !== requiredFragrances) clearPresetState();
      requiredFragrances = nextRequiredFragrances;
      trimFragrances(requiredFragrances);

      if (selectedTitle) selectedTitle.textContent = input.dataset.productTitle || '';
      if (selectedPrice) selectedPrice.textContent = input.dataset.productPrice || '';
      if (selectedImage) {
        selectedImage.src = input.dataset.productImage || '';
        selectedImage.alt = input.dataset.productTitle || '';
      }
      if (selectedSummary) selectedSummary.hidden = false;
      if (submitButton) submitButton.disabled = false;
      if (submitLabel) {
        submitLabel.textContent = `${text.checkout} — ${input.dataset.productPrice || ''}`;
      }
      if (fragrancePanel) fragrancePanel.hidden = requiredFragrances === 0;
      renderFragrances();
      if (errorElement) errorElement.textContent = '';
    }

    function openNativeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    function closeNativeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function openFragranceDialog() {
      openNativeDialog(fragranceDialog);
    }

    function selectProductById(inputId) {
      const input = inputId ? document.getElementById(inputId) : null;
      if (!input || input.disabled) return null;
      input.checked = true;
      updateSelectedProduct(input);
      return input;
    }

    function focusDeliveryOnMobile() {
      if (!deliveryPanel || !window.matchMedia('(max-width: 699px)').matches) return;
      window.setTimeout(() => deliveryPanel.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
    }

    productInputs.forEach((input) => {
      input.addEventListener('change', () => updateSelectedProduct(input));
    });

    const initialProduct = currentProduct();
    if (initialProduct) {
      updateSelectedProduct(initialProduct);
    } else {
      requiredFragrances = 0;
      if (fragrancePanel) fragrancePanel.hidden = true;
      if (selectedSummary) selectedSummary.hidden = true;
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = text.checkout;
    }

    fragranceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.fragranceName;
        const label = button.dataset.fragranceLabel || key;
        if (!key) return;
        clearPresetState();
        if (selectedFragrances.has(key)) {
          selectedFragrances.delete(key);
        } else if (selectedFragrances.size < requiredFragrances) {
          selectedFragrances.set(key, label);
        }
        renderFragrances();
      });
    });

    fragrancePresetButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => applyFragrancePreset(button));
    });

    if (fragranceOpenButton && fragranceDialog) {
      fragranceOpenButton.addEventListener('click', openFragranceDialog);
    }

    fragranceCloseButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeNativeDialog(fragranceDialog);
      });
    });

    if (fragranceDialog) {
      fragranceDialog.addEventListener('click', (event) => {
        if (event.target !== fragranceDialog) return;
        const box = fragranceDialog.getBoundingClientRect();
        const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
        if (!inside && typeof fragranceDialog.close === 'function') fragranceDialog.close();
      });
    }

    productDialogOpenButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.productDialog || '');
        openNativeDialog(dialog);
      });
    });

    productDialogs.forEach((dialog) => {
      Array.from(dialog.querySelectorAll('[data-cp-close-product]')).forEach((button) => {
        button.addEventListener('click', () => closeNativeDialog(dialog));
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
        if (!inside) closeNativeDialog(dialog);
      });

      const mainImage = dialog.querySelector('[data-cp-gallery-main]');
      const thumbnails = Array.from(dialog.querySelectorAll('[data-cp-gallery-thumb]'));
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = thumbnail.dataset.imageUrl || mainImage.src;
          mainImage.alt = thumbnail.dataset.imageAlt || '';
          thumbnails.forEach((item) => item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false'));
        });
      });
    });

    chooseProductButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const input = selectProductById(button.dataset.productInput);
        closeNativeDialog(button.closest('[data-cp-product-dialog]'));
        if (input && Number.parseInt(input.dataset.fragrancesRequired || '0', 10) > 0) {
          window.setTimeout(openFragranceDialog, 0);
        } else if (input) {
          focusDeliveryOnMobile();
        }
      });
    });

    directFragranceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const input = selectProductById(button.dataset.productInput);
        if (input) openFragranceDialog();
      });
    });

    if (fragranceDoneButton) {
      fragranceDoneButton.addEventListener('click', () => {
        if (requiredFragrances > 0 && selectedFragrances.size === requiredFragrances) {
          focusDeliveryOnMobile();
        }
      });
    }

    if (giftToggle && giftMessageField && giftMessage) {
      const syncGiftMessage = () => {
        giftMessageField.hidden = !giftToggle.checked;
        giftMessage.disabled = !giftToggle.checked;
        if (giftToggle.checked) window.setTimeout(() => giftMessage.focus(), 0);
      };
      giftToggle.addEventListener('change', syncGiftMessage);
      syncGiftMessage();
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (errorElement) errorElement.textContent = '';

      const product = currentProduct();
      if (!product) {
        if (errorElement) errorElement.textContent = text.selectProduct;
        return;
      }

      if (requiredFragrances && selectedFragrances.size !== requiredFragrances) {
        if (errorElement) errorElement.textContent = text.selectFragrances;
        openFragranceDialog();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);
      const properties = {
        'Entrega local': 'Cartagena',
        'Fecha de entrega solicitada': formData.get('delivery_date') || '',
        'Franja horaria solicitada': formData.get('delivery_slot') || '',
        'Tipo de lugar': formData.get('place_type') || '',
        'Hotel, alojamiento o barrio': formData.get('delivery_place') || '',
        'Teléfono del destinatario': formData.get('recipient_phone') || '',
        'Tarjeta personalizada': giftToggle && giftToggle.checked ? 'Sí' : 'No'
      };

      if (requiredFragrances) properties.Fragancias = Array.from(selectedFragrances.values()).join(', ');
      if (giftToggle && giftToggle.checked && giftMessage && giftMessage.value.trim()) {
        properties['Mensaje para la tarjeta'] = giftMessage.value.trim();
      }

      submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = text.processing;

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(product.dataset.variantId),
              quantity: 1,
              properties
            }]
          })
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || text.generic);
        }

        const rootPath = root.dataset.rootUrl || '/';
        const checkoutPath = `${rootPath.replace(/\/?$/, '/')}checkout`;
        window.location.assign(checkoutPath);
      } catch (error) {
        if (errorElement) errorElement.textContent = error.message || text.generic;
        submitButton.disabled = false;
        if (submitLabel) submitLabel.textContent = `${text.checkout} — ${product.dataset.productPrice || ''}`;
      }
    });
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-cp-cartagena]').forEach(initCartagenaFunnel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
